<div class="card p-lg-4 p-3 mb-4">
  @if(title()){<h2 class="pb-1">{{ title() }}</h2>}
  @if(description()){<p class="pb-3">{{ description() }}</p>}
  <ng-content></ng-content>
  <mat-progress-bar *ngIf="loading()" mode="indeterminate" class="card-progress-bar"></mat-progress-bar>
</div>
